// The shell's org/user DISPLAY model. Both values are read at runtime: org from deployment config and the
// viewer from the authenticated server Actor joined to Identity's directory. This file keeps only types,
// the harmless org first-paint default, and view-role copy; it contains no compiled-in person identity.
//
// The ORG half is now REAL: it is read at runtime from the box's own
// config through `GET /dashboard/api/org` (see org-display.ts next door) — the constant below survives only
// as the synchronous FALLBACK the org block paints with before that read resolves, and if it ever fails.

import type { DashboardRole } from './surfaces.ts';

/** The org identity shown in the sidebar (name + a mono meta line). */
export interface OrgDisplay {
  readonly name: string;
  readonly meta: string;
}

/** The signed-in user shown in shell chrome. Every field is a server-authored display projection. */
export interface UserDisplay {
  readonly name: string;
  readonly initials: string;
  readonly roleLabel: string;
}

/** The org display the shell paints WHILE the per-Deployment read is in flight, and if that read fails.
 *  These are the exact strings the sidebar used to hardcode, and they are ALSO the config schema's own
 *  defaults — so an un-reconfigured box renders identically whether the read lands or not, and there is
 *  never a blank corner on first paint (a fetch-then-render org block would flash empty chrome). */
export const ORG_DISPLAY: OrgDisplay = {
  name: 'Orange Grove Ltd',
  meta: 'Premium juice · Bristol',
};

/** The human-readable role line under the user's name, per the active role scope. */
export function roleLine(role: DashboardRole): string {
  return role === 'admin_md' ? 'Manager' : 'Operator';
}
